<vex-base-layout *ngIf="config$ | async as config">
  <vex-progress-bar></vex-progress-bar>

  <vex-search></vex-search>

  <mat-sidenav-container class="vex-layout-sidenav-container">
    <mat-sidenav
      (closedStart)="onSidenavClosed()"
      [disableClose]="!!(sidenavDisableClose$ | async)"
      [fixedInViewport]="!!(sidenavFixedInViewport$ | async)"
      [mode]="(sidenavMode$ | async) ?? 'side'"
      [opened]="!!(sidenavOpen$ | async)">
      <vex-sidenav [collapsed]="!!(sidenavCollapsed$ | async)"></vex-sidenav>
    </mat-sidenav>

    <mat-sidenav (closedStart)="onQuickpanelClosed()"
                 [opened]="!!(quickpanelOpen$ | async)"
                 class="vex-layout-quickpanel"
                 mode="over"
                 position="end">
      <vex-quickpanel></vex-quickpanel>
    </mat-sidenav>

    <mat-sidenav-content class="vex-layout-sidenav-content">
      <vex-toolbar [class.dark]="config.layout === 'vertical'" class="vex-toolbar"></vex-toolbar>

      <main class="vex-layout-content">
        <div *ngIf="isRecoverySession$ | async" class="recovery-warning-banner">
          <div class="recovery-warning-inner">
            <mat-icon class="recovery-warning-icon">warning_amber</mat-icon>
            <span class="recovery-warning-text">
              Estás accediendo con tu <strong>código de recuperación</strong>.
              Para proteger tu cuenta y no perder el acceso, te recomendamos cambiar tu contraseña a la brevedad.
            </span>
          </div>
        </div>
        <router-outlet></router-outlet>
      </main>
      <vex-footer></vex-footer>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- CONFIG PANEL TOGGLE - DISABLED FOR PRODUCTION 
  <vex-config-panel-toggle
    (openConfig)="configpanel.open()"></vex-config-panel-toggle>
  -->

  <!-- CONFIGPANEL - DISABLED FOR PRODUCTION
  <vex-sidebar
    #configpanel
    [invisibleBackdrop]="true"
    [opened]="!!(configPanelOpen$ | async)"
    position="right">
    <vex-config-panel></vex-config-panel>
  </vex-sidebar>
  -->
  <!-- END CONFIGPANEL -->
</vex-base-layout>
